import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const editPasswordCacheKey = 'editPassword';
export const editPasswordQuery = graphql(/* GraphQL */ `
    query EditPassword($email: String!) {
        editPassword(email: $email) {
            success
        }
    }
`);
